import {
  AppConfig,
  useSubscriptionAccessConfigContext,
} from '@ltvco/refresh-lib/ctx';
import { SearchReportBanner } from '@ltvco/refresh-lib/fmt';
import { useReportRedirect } from '@ltvco/refresh-lib/v1';
import {
  CollectionType,
  FeatureBlockedModal,
  useFeatureBlockedModal,
  type NullableAdvancedSearchURLParams,
} from '@ltvco/refresh-lib/v2';
import { useContext, useState } from 'react';

import { constants } from 'appConstants';
import imgFamPersonSearchBanner from 'images/imgFamPersonSearchBanner.svg';

interface SearchBannerProps {
  searchParams: NullableAdvancedSearchURLParams;
}

export function AncestorSearchBanner({ searchParams }: SearchBannerProps) {
  const { trackEventGA4 } = useContext(AppConfig);
  const { redirectToSearchPersonUrlv2 } = useReportRedirect();
  const { isBlocked } = useSubscriptionAccessConfigContext();
  const {
    isFeatureBlockedModalOpen,
    openFeatureBlockedModal,
    closeFeatureBlockedModal,
  } = useFeatureBlockedModal();
  const [searchType, setSearchType] = useState<string>('');
  const [paymentShowModalNumber, setPaymentShowModalNumber] =
    useState<number>(0);

  const isDeceased: boolean | undefined =
    !!searchParams.deathYear ||
    (searchParams.birthYear && parseInt(searchParams.birthYear) < 1925)
      ? true
      : undefined;

  const personInfo: NullableAdvancedSearchURLParams = {
    ...searchParams,
    isDeceased,
    advancedSearch: true,
    source: [CollectionType.FAMILY_SEARCH],
  };

  const displayName = searchParams.fName;

  const handleClick = () => {
    trackEventGA4({
      event_name: 'viewed_report',
      interacted_from: 'obituary_report',
      report_type: 'ancestor',
    });
    if (isBlocked('ancestry')) {
      setSearchType('Ancestry');
      openFeatureBlockedModal();
      return;
    }

    redirectToSearchPersonUrlv2(personInfo);
  };

  const description = isDeceased
    ? 'Find out more about their story. FamilySearch users.'
    : 'Search through data and information provided by millions of FamilySearch users.';

  return (
    <>
      <SearchReportBanner
        title={`Look for ${displayName} on`}
        description={description}
        buttonText="Go to Ancestor Report"
        imageSrc={imgFamPersonSearchBanner}
        isDeceased={isDeceased}
        logoSrc={constants.images.familyTreeImages?.imgFamilySearch}
        onButtonClick={handleClick}
      />

      <FeatureBlockedModal
        isOpen={isFeatureBlockedModalOpen}
        onClose={closeFeatureBlockedModal}
        searchType={searchType}
        paymentShowModalNumber={paymentShowModalNumber}
        setPaymentShowModalNumber={setPaymentShowModalNumber}
      />
    </>
  );
}
